import{
    apiRequest,
    periodeVerifikasiDetail,
    periodeVerifikasiUpdate,
    employeeList,
    polaKerjaList
} from "../../../../../services/adapters/kepegawaian/periodeVerifikasiService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", periodeVerifikasiDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", periodeVerifikasiUpdate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }
    fetchPolaKerja = async (query) => {
        return await apiRequest("get", polaKerjaList, {
            params: query
        }, true)
    }
}

export default UpdateRepository